








































import { Component, Prop, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { Mobile } from "@/mixins/mobile";
import { CustomUmbrellaOrder } from "@/models/configurator/custom_umbrella";
import { FabricSwatch } from "@/models/products/fabric";
@Component
export default class QtyPicker extends mixins(Mobile) {
  @Prop() index!: number | string | undefined;
  @Prop() passedQty!: number | undefined;
  @Prop({ default: false }) allowZero!: boolean;
  @Prop() itemDets?: CustomUmbrellaOrder["canopy"];
  private qty = this.allowZero ? 0 : 1;

  @Watch("passedQty", { immediate: true })
  udpateQty(): void {
    if (this.passedQty) {
      this.qty = this.passedQty;
    }
  }

  protected get failsQtyRequirement(): boolean {
    let result = false;
    const allItemFabrics: FabricSwatch[] = [];
    if (this.itemDets) {
      if (this.itemDets.bindingFabric)
        allItemFabrics.push(this.itemDets.bindingFabric);
      if (this.itemDets.ventTrimFabric)
        allItemFabrics.push(this.itemDets.ventTrimFabric);
      if (this.itemDets.mainTrimFabric)
        allItemFabrics.push(this.itemDets.mainTrimFabric);
      if (this.itemDets.mainTrimFabricInner)
        allItemFabrics.push(this.itemDets.mainTrimFabricInner);
      if (this.itemDets.ribFabric) allItemFabrics.push(this.itemDets.ribFabric);
      if (this.itemDets.mainFabric) {
        this.itemDets.mainFabric.forEach((fabric) => {
          allItemFabrics.push(fabric);
        });
      }
      if (this.itemDets.valanceFabric) {
        this.itemDets.valanceFabric.forEach((fabric) => {
          allItemFabrics.push(fabric);
        });
      }
      if (this.itemDets.ventMiddleFabric) {
        this.itemDets.ventMiddleFabric.forEach((fabric) => {
          allItemFabrics.push(fabric);
        });
      }
      if (this.itemDets.ventTopFabric) {
        this.itemDets.ventTopFabric.forEach((fabric) => {
          allItemFabrics.push(fabric);
        });
      }
    }
    allItemFabrics.forEach((fabric) => {
      if (fabric.brand === "Sunbrella" || fabric.brand === "Outdura") {
        fabric.pattern_group?.forEach((pattern) => {
          if (pattern === "Stripes" && this.qty < 2) {
            result = true;
          }
        });
      }
    });
    this.$emit("toggleSubmit", result);
    return result;
  }

  protected qtyKeypress(e: any): void {
    this.$emit("sendQty", this.qty, this.index);
  }

  protected minus(): void {
    const num = this.allowZero ? 0 : 1;
    if (this.qty > num) {
      this.qty--;
      this.$emit("sendQty", this.qty, this.index);
    }
  }

  protected add(): void {
    if (this.qty < 1000) {
      this.qty++;
      this.$emit("sendQty", this.qty, this.index);
    }
  }
}
